<div>
    <h5>{{ 'IDLE_WARNING_TITLE' | translate }}</h5>
    <p>{{ 'IDLE_WARNING_MESSAGE' | translate }}</p>
    <button class="btn btn-primary" (click)="onContinue()">
        Ok
    </button>
</div>